"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsService = void 0;

var auto_bind_1 = __importDefault(require("auto-bind"));

var browser_or_node_1 = require("browser-or-node");

var Market_1 = require("./../market/Market");

var localWindow = browser_or_node_1.isNode ? {} : window;

var AnalyticsService =
/** @class */
function () {
  function AnalyticsService(baseUrl) {
    this.marketService = new Market_1.MarketService(baseUrl);
    auto_bind_1.default(this);
  }

  AnalyticsService.prototype.init = function (marketId) {
    var _this = this;

    this.marketService.getMarketInfo(marketId).then(function (result) {
      result.analyticWriteKey && _this.initScript(result.analyticWriteKey);
    });
  };

  AnalyticsService.prototype.page = function (page) {
    if (browser_or_node_1.isNode) return this;
    var title = page;
    var path = "/virtual/" + this.convertStringToKebabCase(title);
    this.analyticsOnLoad(function () {
      localWindow.analytics.page(title, {
        title: title,
        path: path
      });
    });
    return this;
  };

  AnalyticsService.prototype.track = function (event) {
    if (browser_or_node_1.isNode) return this;
    var title = event;
    var path = "" + this.convertStringToKebabCase(title);
    this.analyticsOnLoad(function () {
      localWindow.analytics.track(title, {
        path: path,
        title: title,
        name: title
      });
    });
    return this;
  };

  AnalyticsService.prototype.event = function (page, event) {
    if (browser_or_node_1.isNode) return this;
    var path = "/virtual/" + this.convertStringToKebabCase(page + " " + event);
    this.analyticsOnLoad(function () {
      localWindow.analytics.page(page, {
        title: page,
        path: path
      });
      localWindow.analytics.track(page + ": " + event, {
        title: page + ": " + event,
        path: path,
        name: page + ": " + event
      });
    });
    return this;
  };

  AnalyticsService.prototype.convertStringToKebabCase = function (string) {
    return string.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_:]+/g, "-").toLowerCase();
  };

  AnalyticsService.prototype.analyticsOnLoad = function (callback) {
    if (!localWindow.analytics) {
      var queue_1 = setInterval(function () {
        if (localWindow.analytics) {
          callback();
          clearInterval(queue_1);
        }
      }, 50);
    } else callback();
  };

  AnalyticsService.prototype.initScript = function (key) {
    var script = document.createElement("script");
    script.innerHTML = "!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Segment snippet included twice.\");else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"debug\",\"page\",\"once\",\"off\",\"on\",\"addSourceMiddleware\",\"addIntegrationMiddleware\",\"setAnonymousId\",\"addDestinationMiddleware\"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement(\"script\");n.type=\"text/javascript\";n.async=!0;n.src=\"https://cdn.segment.com/analytics.js/v1/\"+t+\"/analytics.min.js\";var a=document.getElementsByTagName(\"script\")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION=\"4.1.0\";analytics.load(\"" + key + "\");analytics.page();}}();";
    script.setAttribute("type", "text/javascript");
    document.getElementsByTagName("head")[0].appendChild(script);
    return this;
  };

  return AnalyticsService;
}();

exports.AnalyticsService = AnalyticsService;